function FitnessIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={(size * 32) / 33}
        viewBox='0 0 33 32'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M21.5 15H11.5V18H21.5V15ZM9.5 13V20H23.5V13H9.5Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M27.5 23V10C27.5 8.89543 26.6046 8 25.5 8C24.3954 8 23.5 8.89543 23.5 10V23C23.5 24.1046 24.3954 25 25.5 25C26.6046 25 27.5 24.1046 27.5 23ZM25.5 6C23.2909 6 21.5 7.79086 21.5 10V23C21.5 25.2091 23.2909 27 25.5 27C27.7091 27 29.5 25.2091 29.5 23V10C29.5 7.79086 27.7091 6 25.5 6Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M9.5 23V10C9.5 8.89543 8.60457 8 7.5 8C6.39543 8 5.5 8.89543 5.5 10V23C5.5 24.1046 6.39543 25 7.5 25C8.60457 25 9.5 24.1046 9.5 23ZM7.5 6C5.29086 6 3.5 7.79086 3.5 10V23C3.5 25.2091 5.29086 27 7.5 27C9.70914 27 11.5 25.2091 11.5 23V10C11.5 7.79086 9.70914 6 7.5 6Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M1.5 12C2.05228 12 2.5 12.4477 2.5 13L2.5 20C2.5 20.5523 2.05228 21 1.5 21C0.947715 21 0.5 20.5523 0.5 20L0.5 13C0.5 12.4477 0.947715 12 1.5 12Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M31.5 12C32.0523 12 32.5 12.4477 32.5 13L32.5 20C32.5 20.5523 32.0523 21 31.5 21C30.9477 21 30.5 20.5523 30.5 20L30.5 13C30.5 12.4477 30.9477 12 31.5 12Z'
          fill='currentColor'
        />
      </svg>
    </span>
  );
}

export default FitnessIcon;
